package views.componentes

import androidx.compose.runtime.*
import ffEspHorizontalMM
import fontSmall
import kotlinx.browser.document
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLSelectElement
import org.w3c.dom.Text
import utils.ff.Companion.giId
import utils.ff.Companion.println0
import utils.ffPegaCampo
import utils.ffPegaCampoAlt
import utils.ffPegaCampoAte
import utils.ffZeroLeft

private fun geraId(_tela: String, _id: String, _tipo: String): String {
    var id = _id
    if (id.equals("")) {
        giId += 1;
        id = _tela + "_$_tipo${giId.ffZeroLeft(6)}"
    }
    return id
}

@Composable
fun ffComboBOM(
    _span: String,
    _seOpcao: MutableState<String>,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""

): Unit {

    var classe = ""
    if (!_classes.equals(""))
        classe = "'$_classes'".replace("'", "\"")
    //println0(classe)
    //Div({ classes(classe); style { width(_width.percent) } }) {

    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { org.jetbrains.compose.web.dom.Text(_span) }
        Br()
        Div({ classes("form-group", "input-group-append") }) {
            //Div({classes("dlg-40")}) {

            Select(attrs = {
                _seOpcao.id(geraId("", _id, "combo"))
                id(_seOpcao.id())
                style { fontSize(fontSmall) }
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onChange { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onFocusOut { _ ->
                    _onFocusOut.invoke(true)
                }
            }
            ) {

                val teste = _seOpcao.textItens()
                var bTraco = false
                var bFirst = true
                for (o in teste.split("#")) {

                    var s = o
                    if (o.contains("-"))
                        s = o.ffPegaCampoAte("-")

                    Option(value = s) { org.jetbrains.compose.web.dom.Text("$o") }
                    if (bFirst) {
                        //_seOpcao.textSelect(s)
                        _seOpcao.textSelect(s)
                        bFirst = false
                    }

//                    if (_seOpcao.textSelect().equals("")) {
//                        _seOpcao.textSelect(s)
//                    }

                }
            }
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }

}

@Composable
fun ffCombo11(
    _span: String,
    _seOpcao: MutableState<String>,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""

) {

    var classe = ""
    if (!_classes.equals(""))
        classe = "'$_classes'".replace("'", "\"")
    //println0(classe)
    //Div({ classes(classe); style { width(_width.percent) } }) {

    Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { org.jetbrains.compose.web.dom.Text(_span) }
        Br()
        Div({ classes("form-group", "input-group-append") }) {
            //Div({classes("dlg-40")}) {

            Select(attrs = {
                _seOpcao.id(geraId("", _id, "combo"))
                id(_seOpcao.id())
                style { fontSize(fontSmall) }
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onChange { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onFocusOut { _ ->
                    _onFocusOut.invoke(true)
                }
            }
            ) {

                val teste = _seOpcao.textItens()
                var bFirst = true
                for (o in teste.split("#")) {

                    var s = o
                    if (o.contains("-"))
                        s = o.ffPegaCampoAte("-")

                    Option(value = s) { org.jetbrains.compose.web.dom.Text("$o") }
                    if (bFirst) {
                        _seOpcao.textSelect(s)
                        bFirst = false
                    }

                }
            }
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }

}

/*
@Composable
fun ffComboA(
    _span: String,
    _seOpcao: MutableState<String>,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""
) {
    var classe = ""
    if (_classes.isNotEmpty()) {
        classe = "'$_classes'".replace("'", "\"")
    }

    var firstOption = ""

    Div({
        style {
            width(_width.percent)
            fontSize(fontSmall)
        }
    }) {
        Span { org.jetbrains.compose.web.dom.Text(_span) }
        Br()
        Div({
            classes("form-group", "input-group-append")
        }) {
            Select(attrs = {
                _seOpcao.id(geraId("", _id, "combo"))
                id(_seOpcao.value)
                style { fontSize(fontSmall) }
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput {
                    _seOpcao.textSelect(it.value)
                    println0(_seOpcao.textSelect())
                }
                onChange {
                    _seOpcao.textSelect(it.value)
                    println0(_seOpcao.textSelect())
                }
                onFocusOut {
                    if (_seOpcao.textSelect().isEmpty()) {
                        _seOpcao.textSelect(firstOption)
                    }
                    _onFocusOut.invoke(true)
                }
            }) {
                val teste = _seOpcao.textItens()
                var bFirst = true
                for (o in teste.split("#")) {
                    var s = o
                    if (o.contains("-")) {
                        s = o.ffPegaCampoAte("-")
                    }
                    Option(value = s) { org.jetbrains.compose.web.dom.Text(o) }
                    if (bFirst) {
                        firstOption = s
                        bFirst = false
                    }
                }
            }
            if (_esp) {
                ffEspHorizontalMM(3)
            }
        }
    }
}

 */


/*
@Composable
fun ffCombo(
    _span: String,
    _seOpcao: MutableState<String>,
    _sPartPosicao: String,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""

) {

    var classe = ""
    if (_classes.isNotEmpty()) {
        classe = "'$_classes'".replace("'", "\"")
    }


    Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { org.jetbrains.compose.web.dom.Text(_span) }
        Br()
        Div({ classes("form-group", "input-group-append") }) {
            //Div({classes("dlg-40")}) {

            Select(attrs = {
                _seOpcao.id(geraId("", _id, "combo"))
                id(_seOpcao.id())
                style { fontSize(fontSmall) }
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onChange { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onFocusOut { _onFocusOut.invoke(true) }
            }
            ) {

                val teste = _seOpcao.textItens()
                var bFirst = true
                for (o in teste.split("#")) {

                    var s = o
                    if (o.contains("-"))
                        s = o.ffPegaCampoAte("-")

                    Option(value = s) { org.jetbrains.compose.web.dom.Text("$o") }
                    if ((bFirst) && (o.contains(_sPartPosicao) || _sPartPosicao.isEmpty())) {
                        println("_textSelect o=$o s=$s _sPartPosicao=$_sPartPosicao _carregado=${_seOpcao.carregado()}")
                        _seOpcao.textSelect(o)
                        bFirst = false
                    }

                }
            }

            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

 */

/*
if (_seOpcao.textSelect().isNotEmpty() && _seOpcao.carregado() == "nao") {
    _seOpcao.comboLocaliza(_seOpcao.textSelect())
}

 */
/*
if (_seOpcao.textSelect().isNotEmpty() && _seOpcao.carregado() == "nao") {
    _seOpcao.comboLocaliza(_seOpcao.textSelect())
    _seOpcao.carregado("sim")
}

 */


@Composable
fun ffCombo1(
    _span: String,
    _seOpcao: MutableState<String>,
    _sPartPosicao: String,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""
) {
    var classe = ""
    if (_classes.isNotEmpty()) {
        classe = "'$_classes'".replace("'", "\"")
    }

    Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { org.jetbrains.compose.web.dom.Text(_span) }
        Br()
        Div({ classes("form-group", "input-group-append") }) {
            Select(attrs = {
                _seOpcao.id(geraId("", _id, "combo"))
                id(_seOpcao.id())
                style { fontSize(fontSmall) }
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onChange { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onFocusOut { _onFocusOut.invoke(true) }
            }) {
                val teste = _seOpcao.textItens()
                var bFirst = true
                for (o in teste.split("#")) {
                    val s = if (o.contains("-")) o.substringBefore("-") else o
                    Option(value = s) { org.jetbrains.compose.web.dom.Text(o) }

                    if (bFirst && (o.contains(_sPartPosicao) || _sPartPosicao.isEmpty())) {
                        println("_textSelect o=$o s=$s sPartPosicao=$_sPartPosicao carregado=${_seOpcao.carregado()}")
                        _seOpcao.textSelect(o)
                        bFirst = false
                        //_seOpcao.comboLocaliza(_seOpcao.textSelect())
                    }
                }
            }

            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@Composable
fun ffCombo(
    _span: String,
    _seOpcao: MutableState<String>,
    _sPartPosicao: String,
    _width: Int,
    _classes: String,
    _esp: Boolean,
    _onFocusOut: (Boolean) -> Unit,
    _id: String = ""
) {

    println("ffCombo _seOpcao=${_seOpcao.textItens()}")
    var classe = ""
    if (_classes.isNotEmpty()) {
        classe = "'$_classes'".replace("'", "\"")
    }

// Definir o valor inicial do Select
    val teste = _seOpcao.textItens()
    val firstItem = teste.split("#").firstOrNull { it.contains(_sPartPosicao) || _sPartPosicao.isEmpty() }
    if (firstItem != null && _seOpcao.textSelect().isEmpty()) {
        _seOpcao.textSelect(firstItem)
    }

    Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { org.jetbrains.compose.web.dom.Text(_span) }
        Br()
        Div({ classes("form-group", "input-group-append") }) {
            Select(attrs = {
                _seOpcao.id(geraId("", _id, "combo"))
                id(_seOpcao.id())
                style { fontSize(fontSmall) }
                classes("custom-select", "mr-sm-2", "dlg-100")
                onInput { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onChange { _seOpcao.textSelect(it.value); println0(_seOpcao.textSelect()) }
                onFocusOut { _onFocusOut.invoke(true) }
            }) {
                for (o in teste.split("#")) {
                    if (!o.trim().equals("")) {
                        val s = if (o.contains("-")) o.substringBefore("-") else o
                        Option(value = s) { org.jetbrains.compose.web.dom.Text(o) }
                    }
                }
            }

            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@NonRestartableComposable
fun MutableState<String>.textSelect(_new: String? = "null"): String {

    //return this.value
    var sResult = ""
    if (_new != null) {
        if (!_new.equals("null") && !_new.equals("")) {
            if (!this.value.ffPegaCampo("|textselect=").equals(_new))
                this.value = this.value.ffPegaCampoAlt("|textselect=", _new)
        }
    }
    sResult = this.value.ffPegaCampo("|textselect=")
    println0("@textSelect=$sResult")
    //if (sResult.equals("") && this.selectExiste()) {
//        this.selectElement()!!.value =
//    }
//    if (sResult == "" && this.value.ffPegaCampo("|textselect=")
    return sResult

}

@NonRestartableComposable
fun MutableState<String>.selectLocalize(_textPart: String): String {

    //return this.value
    var sResult = ""
    val teste = this.textItens()
    for (o in teste.split("#")) {

        if (o.contains(_textPart)) {
            sResult = o
            break
        }
    }

    println0("@selectLocalize _textPart=$_textPart sResult=$sResult")
    return sResult

}

fun MutableState<String>.comboLocaliza(_textPart: String) {

    //if (!this.textSelect().contains(_textPart)) {
    val teste = this.textItens()
    println0("@comboLocaliza _textPart=$_textPart")
    for (o in teste.split("#")) {

        if (o.contains(_textPart)) {
            //this.textSelect(o)
            var s = o
            if (o.contains("-"))
                s = o.ffPegaCampoAte("-")
            this.selectElement()!!.value = s
            //this.textSelect(o)
            break
        }
    }
    //}

}

@NonRestartableComposable
fun MutableState<String>.selectExiste(): Boolean {

    var bResult = false

    val text: HTMLSelectElement? = this.getHTMLSelectElement1()
    if (text != null)
        bResult = true

    return bResult
}

@NonRestartableComposable
fun MutableState<String>.selectElement(): HTMLSelectElement? {

    var text: HTMLSelectElement? = null
    if (this.selectExiste())
        text = this.getHTMLSelectElement1()

    return text
}
/*
fun MutableState<String>.getHTMLSelectElement1(): HTMLSelectElement? {

    if (!this.id().equals("") && document.getElementById(this.id()) != null) {
        val teste = document.getElementById(this.id()) as HTMLSelectElement
        if (!this.textSelect().contains(teste.value)) {
            this.textSelect(teste.value)
        }
        //println0("getHTMLSelectElement encontrado ${teste!!.id}")
        return teste
    } else {
        return null
    }

}

 */

private fun MutableState<String>.getHTMLSelectElement1(): HTMLSelectElement? {
    val elementId = this.id()
    val selectElement = document.getElementById(elementId) as? HTMLSelectElement
    selectElement?.let {
        println0("getHTMLSelectElement encontrado ${it.id} contem=${it.value}")
    }
    return selectElement
}

fun MutableState<String>.selectCount(_textPart: String): Int {

    var iCont = 0
    val teste = this.textItens()
    for (o in teste.split("#")) {

        if (o.contains(_textPart) || _textPart.isEmpty()) {
            if (!o.trim().equals(""))
                iCont += 1
        }
    }
    println0("@selectCount _textPart=$_textPart count=$iCont")
    return iCont

}
